import { render, staticRenderFns } from "./superadmin-contact-relations-migration-settings.vue?vue&type=template&id=fe791abc&scoped=true&"
import script from "./superadmin-contact-relations-migration-settings.vue?vue&type=script&lang=ts&"
export * from "./superadmin-contact-relations-migration-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe791abc",
  null
  
)

export default component.exports